export enum TabsState {
  Upcoming = 0,
  Previous = 1,
}
